<template>
  <v-card
    flat
    width="192"
    height="128"
    color="white"
    class="d-flex align-center justify-center"
  >
    <v-img
      class="px-2"
      style="width: inherit"
      :src="getUrl(partner.imageUrl)"
      contain
    />
  </v-card>
</template>

<script>
export default {
  props: {
    partner: Object,
  },
  methods: {
    getUrl(imageUrl) {
      return process.env.VUE_APP_ID4Server + imageUrl;
    },
  },
};
</script>

<style>
</style>